<template>
  <div class="testimonial">
    <img :src="image" :alt="name" class="testimonial-image" />
		<p class="testimonial-name">{{name}}</p>
    <p>{{body}}</p>
  </div>
</template>
<script>
export default {
	name: 'testimonial',

	props: {
		name: {
			type: String,
			required: true,
		},
		image: {
			type: String,
			required: true,
		},
		body: {
			type: String,
			required: true,
		},
	},
};
</script>
<style lang="scss" scoped>
  .testimonial {

		&-image {
			max-width: 3.75rem;
			margin-right: 0.5rem;
			float: left;
			border-radius: 50%;
		}

		&-name {
			font-weight: bold;
		}
  }
</style>
